export const colors = {
  primary: {
    mainGreen: '#8BB770',
    lightGreen: '#C5DBB8',
    darkGreen: '#0E7432',
    complimentaryGreen: '#04A13B',
  },
  background: {
    main: '#F0F0F0',
    black: '#06180F',
    white: '#ffffff',
    disabled: '#D5D5D5',
  },
  secondary: {
    lightBlue: '#E2E9EA',
    mediumBlue: '#78A5CB',
    blueGrey: '#B6C4C7',
    darkBlueGrey: '#98ADB1',
    sand: '#EEEBE8',
    beige: '#DCD5CF',
    brown: '#BBB2AB',
    yellowBrand: '#EDD05F',
    lightYellow: '#F6E8AF',
    red: '#BD0909',
    lightRed: '#DF5F36',
    black: '#000000',
    light: '#F9F9F9',
  },
  text: {
    primary: '#1C1C1C',
    secondary: '#4f4f4f',
    tertiary: '#616a6e',
  },
  error: {
    main: '#f2653d',
    dark: '#BD0909',
    light: '#DF5F36',
  },
};
